import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isEmployeeWorkspacePath, isLinkedAdmin } from "@/utils/workspace";

// True where the signed-in person is acting as an employee: an employee login
// anywhere, or an admin who is also an employee while in "My workspace".
export const useActsAsEmployee = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  return (
    user?.role === "employee" ||
    (isLinkedAdmin(user) && isEmployeeWorkspacePath(pathname))
  );
};
